angular.module('components.media.ImageController', [
  'global',
  'components.media.ImageService'
])

/**
 * The ImageController manages scope logic and user
 * interaction.
 *
 * @class ImageController
 * @constructor
 * @module components.media.ImageController
 */
.controller('ImageController', [
  '$scope',
  function ($scope) {
    'use strict';

    $scope.formattedModel = {};

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      $scope.formattedModel = _.clone($scope.model);
    }

    initialize();
  }
]);
